import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionListItem } from 'components/ActionList'
import { City } from '../../../../data/models/funnelOrder/cities'
import { destinationEnum } from '../../../../data/models/funnelOrder/destination'
import { AppState } from '../../../../data/state'
import FlyExcludeModal from '../../../../elements/modals/FlyExcludeModal'

interface FlyExcludedOptionProps {
  destination: destinationEnum
  excludedCities: City[]
  max?: number
}

interface FlyExcludedOptionState {
  showModal: boolean
}

class FlyExcludedOption extends React.Component<
  FlyExcludedOptionProps,
  FlyExcludedOptionState
> {
  constructor(props: FlyExcludedOptionProps) {
    super(props)
    this.state = {
      showModal: false,
    }
  }

  public render() {
    const { destination } = this.props

    return (
      <>
        <ActionListItem
          icon={SRPRS.mapMarkerColored}
          iconProps={{
            width: '37',
            height: '37',
            viewBox: '0 0 37 41',
            fill: 'none',
          }}
          subject={
            <DisplayContent contentKey="exclude-cities-option">
              Exclude Cities
            </DisplayContent>
          }
          value={this.getExcludedCitiesList()}
          onClick={this.toggleModal}
        />
        {this.state.showModal ? (
          <FlyExcludeModal
            icon={SRPRS.mapMarkerColored}
            destination={destination}
            max={this.props.max}
            onClose={() => this.setState({ showModal: false })}
          />
        ) : null}
      </>
    )
  }

  private getExcludedCitiesList = () => {
    if (this.props.excludedCities.length === 0) {
      return (
        <DisplayContent contentKey="no-excluded-cities">
          No excluded cities
        </DisplayContent>
      )
    }
    return this.props.excludedCities.map(x => x.name).join(', ')
  }

  private toggleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }
}

export default connect((state: AppState) => ({
  destination: state.funnelOrder.destination,
  excludedCities: state.funnelOrder.excludedCitiesIds,
}))(FlyExcludedOption)
